
export default function HubDashboard() {
  const hubs = [
    {
      id: 'wholesale',
      title: '批发集散中心',
      subtitle: '现货混批 · 拼柜发货 · 快速补货',
      description: '现货混批、拼柜发货、快速补货',
      icon: 'store-2',
      color: '#8B1A1A',
      features: [
        '支持多品类混批，降低采购门槛',
        '灵活拼柜服务，优化物流成本',
        '15天快速补货周期保障'
      ],
      link: '查看批发规则',
      linkIcon: 'arrow-right'
    },
    {
      id: 'park',
      title: '跨境电商园区',
      subtitle: '平台招商 · 孵化服务 · 生态协同',
      description: '平台招商、孵化服务、生态协同',
      icon: 'global',
      color: '#C9A84C',
      features: [
        '对接主流跨境电商平台',
        '提供选品、运营、物流一站式服务',
        '入驻企业享受政策扶持'
      ],
      link: '申请入驻',
      linkIcon: 'login-box'
    },
    {
      id: 'delivery',
      title: '履约合规中心',
      subtitle: '质检认证 · 物流清关 · 售后保障',
      description: '质检认证、物流清关、售后保障',
      icon: 'shield-check',
      color: '#7A3B1E',
      features: [
        '国家+品类智能匹配合规方案',
        '质检认证文件一站式办理',
        '海外仓储与清关服务对接'
      ],
      link: '获取交付方案',
      linkIcon: 'file-list-3'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">三大业务中枢</h2>
          <p className="text-lg text-gray-500 max-w-[560px] mx-auto">
            批发、园区、履约三位一体，构建完整跨境供给生态
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {hubs.map((hub) => (
            <div
              key={hub.id}
              className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer group"
            >
              <div
                className="w-16 h-16 flex items-center justify-center rounded-2xl mb-6 group-hover:scale-110 transition-transform"
                style={{ backgroundColor: `${hub.color}15` }}
              >
                <i
                  className={`ri-${hub.icon}-line text-3xl`}
                  style={{ color: hub.color }}
                ></i>
              </div>

              <div className="mb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-1">{hub.title}</h3>
                <p className="text-sm text-gray-400">{hub.subtitle}</p>
              </div>

              <p className="text-sm text-gray-600 mb-6 leading-relaxed">{hub.description}</p>

              <ul className="space-y-3 mb-6">
                {hub.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div
                      className="w-5 h-5 flex items-center justify-center rounded mt-0.5 shrink-0"
                      style={{ backgroundColor: `${hub.color}18` }}
                    >
                      <i className="ri-check-line text-sm" style={{ color: hub.color }}></i>
                    </div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className="w-full px-6 py-3 rounded-xl font-bold text-white transition-all whitespace-nowrap cursor-pointer hover:shadow-lg hover:-translate-y-0.5"
                style={{ backgroundColor: hub.color }}
              >
                {hub.link}
                <i className={`ri-${hub.linkIcon}-line ml-2`}></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
